import { useState, useEffect, useRef } from "react";
import {
  ContainerHeader,
  LogoWrapper,
  MenuIcon,
  MenuOverlay,
  MenuContent,
  CloseIcon,
  MenuDesktop,
  ProfileWrapper,
  ProfileIcon,
  DropdownMenu,
} from "./LoggedHeaderStyles";
import { useNavigate, useLocation } from "react-router-dom";
import LogoAnimated from "../logoAnimated/LogoAnimated";
import MenuIconImg from "../../img/menu.png";
import UserIcon from "../../img/logged/user.png";

export default function LoggedHeader() {
  const [open, setOpen] = useState(false); // menu mobile
  const [isDesktop, setIsDesktop] = useState(window.innerWidth > 1024);
  const [dropdownOpen, setDropdownOpen] = useState(false); // dropdown desktop

  const navigate = useNavigate();
  const location = useLocation();

  const dropdownRef = useRef<HTMLDivElement>(null);

  const toggleDropdown = () => setDropdownOpen((prev) => !prev);

  const handleLogout = () => {
    localStorage.removeItem("user_token");
    localStorage.removeItem("user_data");
    navigate("/");
  };

  const handleNavigateTo = (path: string) => {
    setOpen(false);
    setDropdownOpen(false);
    navigate(path);
  };

  // Fecha tudo quando a rota (ou hash) muda
  useEffect(() => {
    setOpen(false);
    setDropdownOpen(false);
  }, [location.pathname, location.hash]);

  // Fecha dropdown ao clicar fora (desktop)
  useEffect(() => {
    function handleClickOutside(e: MouseEvent) {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(e.target as Node)
      ) {
        setDropdownOpen(false);
      }
    }
    if (dropdownOpen)
      document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [dropdownOpen]);

  // Fecha com ESC
  useEffect(() => {
    function onKeyDown(e: KeyboardEvent) {
      if (e.key === "Escape") {
        setOpen(false);
        setDropdownOpen(false);
      }
    }
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, []);

  // Atualiza breakpoint e fecha menus ao trocar de layout
  useEffect(() => {
    const handleResize = () => {
      const nowDesktop = window.innerWidth > 1024;
      setIsDesktop(nowDesktop);
      // ao mudar o modo, fecha qualquer menu aberto
      setOpen(false);
      setDropdownOpen(false);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Clique no fundo do overlay fecha o menu mobile
  const handleOverlayClick: React.MouseEventHandler<HTMLDivElement> = (e) => {
    if (e.target === e.currentTarget) setOpen(false);
  };

  return (
    <ContainerHeader>
      <LogoWrapper>
        <LogoAnimated />
      </LogoWrapper>

      {isDesktop ? (
        <MenuDesktop>
          <ProfileWrapper ref={dropdownRef}>
            <ProfileIcon
              onClick={toggleDropdown}
              aria-haspopup="menu"
              aria-expanded={dropdownOpen}
            >
              <img src={UserIcon} alt="Perfil" />
            </ProfileIcon>

            {dropdownOpen && (
              <DropdownMenu role="menu">
                <button onClick={() => handleNavigateTo("/perfil")}>
                  Perfil
                </button>
                <button onClick={handleLogout}>Sair</button>
              </DropdownMenu>
            )}
          </ProfileWrapper>
        </MenuDesktop>
      ) : (
        <>
          <MenuIcon onClick={() => setOpen(true)}>
            <img src={MenuIconImg} alt="Menu" />
          </MenuIcon>

          {open && (
            <MenuOverlay onClick={handleOverlayClick}>
              <CloseIcon onClick={() => setOpen(false)}>×</CloseIcon>

              <div style={{ marginBottom: "3rem" }}>
                <LogoAnimated />
              </div>

              <MenuContent>
                <a onClick={() => handleNavigateTo("/logged-home")}>Início</a>
                <a onClick={() => handleNavigateTo("/perfil")}>Meu Perfil</a>
                <a onClick={handleLogout}>Sair</a>
              </MenuContent>
            </MenuOverlay>
          )}
        </>
      )}
    </ContainerHeader>
  );
}
